import React from 'react';

const TILE = 'rounded-[6px]';

const gradient = (from: string, to: string, angle = '180deg') => ({
	backgroundImage: `linear-gradient(${angle}, ${from}, ${to})`,
});

export function MixSwatch() {
	return (
		<div className="flex h-[105px] w-[153px] gap-[5px]" aria-hidden="true">
			<span className={`${TILE} w-[45px]`} style={gradient('#0096bc', '#006882')} />
			<div className="flex w-[55px] flex-col gap-[4px]">
				<span className={`${TILE} h-[62px]`} style={gradient('#bbeeff', '#5ad5ff')} />
				<span className={`${TILE} flex-1`} style={gradient('#004f68', '#001f29', '144deg')} />
			</div>
			<div className="flex w-[43px] flex-col gap-[4px]">
				<span className={`${TILE} h-[48px]`} style={gradient('#3edab6', '#01a57f')} />
				<span className={`${TILE} h-[27px]`} style={gradient('#869499', '#364b53', '142deg')} />
				<span className={`${TILE} flex-1`} style={gradient('#1ca7b3', '#0c484d', '147deg')} />
			</div>
		</div>
	);
}
